import { Component } from 'react';
import { connect } from 'react-redux';

import { Redirect } from '../../components/Redirect';

import { tokenLoginRequest } from '../../actions/user';

interface Props {
  token: string;
  tokenLoginRequest: typeof tokenLoginRequest;
  error: boolean;
}

class _TokenLogin extends Component<Props> {
  componentDidMount(): void {
    const { token, tokenLoginRequest } = this.props;

    tokenLoginRequest({ token });
  }

  render() {
    const { error } = this.props;

    if (!error) {
      return null;
    }

    return <Redirect to={'/'} />;
  }
}

export const TokenLogin = connect(null, { tokenLoginRequest })(_TokenLogin);
